<template>
  <div class="help-modal" :class="{ mobile: isMobile }">
    <div class="modal-window">
      <span aria-hidden="true" class="modal-window__close" @click="closeModal"
        >&times;</span
      >
      <template v-if="currentStep === 1">
        <h5>Select another origin AS</h5>
        <p>
          Use the drop-downs to change the member account if needed and select
          another origin AS.
        </p>
        <div class="img-wrapper">
          <img
            v-lazy="
              isMobile
                ? '/static/report/help_4.png'
                : '/static/report/help_1.png'
            "
            alt="help image 1"
          />
        </div>
      </template>

      <template v-if="currentStep === 2">
        <h5>Click on download icon</h5>
        <p>
          On the suspicious traffic dashboard page, click on the download icon.
          You will view the report options for the selected origin AS.
        </p>
        <div class="img-wrapper">
          <img
            v-lazy="
              isMobile
                ? '/static/report/help_5.png'
                : '/static/report/help_2.png'
            "
            alt="help image 2"
          />
        </div>
      </template>

      <template v-if="currentStep === 3">
        <h5>Select set up a recurring report</h5>
        <p>
          Select the first option to set up a new recurring report for the
          selected origin AS.
        </p>
        <div class="img-wrapper">
          <img
            v-lazy="
              isMobile
                ? '/static/report/help_6.png'
                : '/static/report/help_3.png'
            "
            alt="help image 2"
          />
        </div>
      </template>
      <div class="modal-window__footer">
        <div>
          <button
            class="btn btn-outline-primary"
            @click="currentStep--"
            v-if="currentStep > 1"
          >
            Back
          </button>
          <button class="btn btn-primary" @click="onNext">
            {{ currentStep === 3 ? 'Done' : 'Next' }}
          </button>
        </div>
        <p>Step {{ currentStep }} of 3</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentStep: 1
    };
  },
  methods: {
    closeModal() {
      this.$emit('close', true);
    },
    onNext() {
      if (this.currentStep === 3) {
        return this.$emit('close', true);
      }
      this.currentStep++;
    }
  },
  computed: {
    isMobile() {
      return this.$store.getters['isSmallerScreen'];
    }
  }
};
</script>

<style lang="scss" scoped>
.help-modal {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba($color: #000000, $alpha: 0.7);
  display: flex;
  justify-content: center;
  align-items: center;

  .modal-window {
    width: 467px;
    height: 572px;
    background: white;
    position: relative;
    padding: 24px;
    display: flex;
    flex-direction: column;

    &__close {
      position: absolute;
      right: 16px;
      top: 16px;
      font-weight: 700;
      font-size: 32px;
      color: #000000;
      cursor: pointer;
      line-height: 1;
    }

    h5 {
      font-size: 24px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 32px;
    }

    .img-wrapper {
      flex: 1;
      position: relative;
      width: 100%;
      height: 200px;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    &__footer {
      margin-top: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      p {
        margin-bottom: 0;
      }

      button.btn-outline-primary {
        margin-right: 8px;
      }
    }
  }
}

.mobile.help-modal {
  .modal-window {
    width: 95%;
    height: 90%;
  }

  h5 {
    font-size: 18px;
  }

  .modal-window__footer {
    .btn {
      min-width: 6.5rem;
    }

    & > p {
      font-size: 14px;
    }
  }
}
</style>
